import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { generateSharedBlock } from "../../../Shared/components/ContentBlocks/shared_blocks";
import { VideoBlock } from "../../../Shared/components/ContentBlocks/VideoBlock/VideoBlockLayout";
import { generalContentPageBlocks } from "../../custom_api/drupal_node_conversion";
import { ButtonBlock } from "../components/button_block";
import { FaqBlock } from "../components/faq_block";
import { HighlightBlock } from "../components/highlight_block";
import { ImageBlock } from "../components/image_block";
import { Container } from "../components/library/container";
import { RichTextBlock } from "../components/rich_text_block";
import { AsyncBlock } from "./async_block";
import { BooksBlock } from "./books_block";
import { CarouselContentGridBlock } from "./carousel_content_grid_block";
import { CollectionBlock } from "./collection_block";
import CollectionSearchBar from "./collection_search_bar";
import { ContentGridBlock } from "./content_grid_block";
import { CtaBlock } from "./cta_block";
import { FeaturedContentBlock } from "./featured_content_block";
import { FormstackBlock } from "./formstack/formstack_block";
import { GridBlock } from "./grid_block";
import { ImagesBlock } from "./images_block";
import { NewsletterFormBlock } from "./newsletterFormBlock/newsletterFormBlockLayout";
import { QuoteBlock } from "./quote_block";
import { SubMenuBlock } from "./submenu_block";
import { HarcodedSubscriptionBlock } from "./subscriptions_block";
import { ThemakiezerBlock } from "./ThemakiezerBlock/ThemakiezerBlockWidget";
import { TippedActivitiesWidget } from "./tippedActivities/tippedActivities.widget";
import { VacancyOverviewBlock } from "./vacancy_overview_block";
import { WordCloudBlock } from "./word_cloud_block";
export const Blocks = (props)=>/*#__PURE__*/ _jsx(BlockRenderer, {
        blocks: generalContentPageBlocks(props.blocks)
    });
export class BlockRenderer extends React.Component {
    render() {
        const p = this.props;
        if (p.blocks.isEmpty()) return /*#__PURE__*/ _jsx(_Fragment, {});
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(Container, {
                children: p.blocks.map((b, i, l)=>{
                    var _l_get;
                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            generateBlock(b),
                            /*#__PURE__*/ _jsx("hr", {
                                className: `after-${b.kind} before-${(_l_get = l.get(i + 1)) === null || _l_get === void 0 ? void 0 : _l_get.kind}`
                            })
                        ]
                    }, `block-${i}`);
                }).toArray()
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {};
    }
}
export const generateBlock = (b)=>b.kind == "richText" ? /*#__PURE__*/ _jsx(RichTextBlock, {
        ...b
    }) : b.kind == "image" ? /*#__PURE__*/ _jsx(ImageBlock, {
        ...b
    }) : b.kind == "video" ? /*#__PURE__*/ _jsx(VideoBlock, {
        ...b
    }) : b.kind == "faq" ? /*#__PURE__*/ _jsx(FaqBlock, {
        ...b
    }) : b.kind == "highlight" ? /*#__PURE__*/ _jsx(HighlightBlock, {
        ...b
    }) : b.kind == "images" ? /*#__PURE__*/ _jsx(ImagesBlock, {
        ...b
    }) : b.kind == "content_grid" ? /*#__PURE__*/ _jsx(ContentGridBlock, {
        ...b
    }) : b.kind == "carousel_content_grid" ? /*#__PURE__*/ _jsx(CarouselContentGridBlock, {
        ...b
    }) : b.kind == "async_block" ? /*#__PURE__*/ _jsx(AsyncBlock, {
        ...b
    }) : b.kind == "knop" ? /*#__PURE__*/ _jsx(ButtonBlock, {
        ...b
    }) : b.kind == "subscription_block" ? /*#__PURE__*/ _jsx(HarcodedSubscriptionBlock, {}) : b.kind == "vacancy_overview" ? /*#__PURE__*/ _jsx(VacancyOverviewBlock, {
        ...b
    }) : b.kind == "books" ? /*#__PURE__*/ _jsx(BooksBlock, {
        ...b
    }) : b.kind == "themakiezer" ? /*#__PURE__*/ _jsx(ThemakiezerBlock, {
        ...b
    }) : b.kind == "collection" ? /*#__PURE__*/ _jsx(CollectionBlock, {
        ...b
    }) : b.kind == "featured_content" ? /*#__PURE__*/ _jsx(FeaturedContentBlock, {
        ...b
    }) : b.kind == "quote" ? /*#__PURE__*/ _jsx(QuoteBlock, {
        ...b
    }) : b.kind == "collection_search_bar" ? /*#__PURE__*/ _jsx("section", {
        className: "search-wrapper",
        children: /*#__PURE__*/ _jsx(CollectionSearchBar, {
            ...b
        })
    }) : b.kind == "grid_block" ? /*#__PURE__*/ _jsx(GridBlock, {
        ...b
    }) : b.kind == "tipped_activities" ? /*#__PURE__*/ _jsx(TippedActivitiesWidget, {
        ...b
    }) : b.kind == "word_cloud_block" ? /*#__PURE__*/ _jsx(WordCloudBlock, {
        ...b
    }) : b.kind == "formstack_block" ? /*#__PURE__*/ _jsx(FormstackBlock, {
        ...b
    }) : b.kind == "cta_block" ? /*#__PURE__*/ _jsx(CtaBlock, {
        ...b
    }) : b.kind == "newsletterForm" ? /*#__PURE__*/ _jsx(NewsletterFormBlock, {
        ...b
    }) : b.kind == "submenu" ? /*#__PURE__*/ _jsx(SubMenuBlock, {
        ...b
    }) : b.kind == "activity_cluster" || b.kind == "empty" ? /*#__PURE__*/ _jsx(_Fragment, {}) : generateSharedBlock(b) ?? ((block)=>{
        console.warn("no renderer found for:", block);
        return /*#__PURE__*/ _jsx(_Fragment, {});
    })(b);
